import styles from './AppErrorFallbackPage.module.scss';

import paymentUserError from '@/assets/img/paymentUserError.jpg';
import { Button } from '@/shared/ui-kit/Button/Button';
import { Modal } from '@/shared/ui-kit/Modal/Modal';

export function AppErrorFallbackPage() {
  const reload = () => window.location.reload();

  return (
    <>
      <title>Не удалось загрузить страницу — Order2Go.ru</title>
      <Modal open onClose={reload}>
        <div className={styles.container}>
          <h2 className={styles.title}>Не удалось загрузить страницу</h2>
          <div className={styles.imageContainer}>
            <img src={paymentUserError} alt="" />
            <div className={styles.textContainer}>
              <p className={styles.text}>Иногда такое бывает</p>
              <p className={styles.textSub}>Попробуйте обновить страницу</p>
            </div>
          </div>
          <Button className={styles.button} onClick={reload}>
            Обновить
          </Button>
        </div>
      </Modal>
    </>
  );
}
